import type { FreeToSpend, FreeToSpendPatch, PlannedSpendingItem } from './freeToSpendTypes';
import { mkFreeToSpend } from './freeToSpendTypes';

export function transformResponseToFreeToSpend(response: any) {
  return response?.data?.resources?.map((fts: FreeToSpend) => mkFreeToSpend(fts));
}

export function transformRequestDataToFreeToSpend(request: any) {
  return { ...(request.toJS ? request.toJS() : request) };
}

// QCS copies each item's rollover type from the month being saved into every later month. Rollovers only change from
// the current month on, so a past month's type stays out of the request: sending it would undo any change made since.
// An item QCS has not created yet keeps its type, because it needs one.
export function transformPastMonthRequestDataToFreeToSpend(request: FreeToSpend | FreeToSpendPatch): object {
  const data = transformRequestDataToFreeToSpend(request);
  if (!data.plannedSpendingItems) return data;
  return {
    ...data,
    plannedSpendingItems: data.plannedSpendingItems.map(({ rolloverType, ...item }: PlannedSpendingItem) =>
      item.id ? item : { ...item, rolloverType },
    ),
  };
}

// QCS also copies each recurring item's name and target into every later month. It skips the fields a request leaves
// out, and without doPatch it keeps the items too, so a rollover change sent alone leaves every month's values as they
// are. `recurring` stays, because QCS only sets a rollover type next to it. An item QCS has not created yet needs all
// its fields.
export function transformRolloverRequestDataToFreeToSpend(
  request: FreeToSpend | FreeToSpendPatch,
  filterId: string,
): object {
  const data = transformRequestDataToFreeToSpend(request);
  const item: PlannedSpendingItem | undefined = data.plannedSpendingItems?.find(
    (plannedItem: PlannedSpendingItem) => plannedItem.filterId === filterId,
  );
  if (!item?.id) return data;
  const { id, recurring, rolloverType, resetRolloverAmount } = item;
  return { id: data.id, plannedSpendingItems: [{ id, filterId, recurring, rolloverType, resetRolloverAmount }] };
}
